import { gql } from 'graphql-request';

export const FETCH_PERSONALISED_CONTENT_QUERY = gql`
  query ($filter: PersonalizedFilter!) {
    personalizedContent(filter: $filter) {
      personalizedRails {
        id
        title
        originalTitle
        image {
          __typename
          list
          cover
          listClean
        }
        genres {
          __typename
          id
          value
        }
        tags
        slug
        position
        contents {
          ... on Movie {
            __typename
            id
            title
            originalTitle
            description
            assetSubType
            image {
              __typename
              list
              cover
              listClean
            }
            duration
            contentOwner
            genres {
              __typename
              id
              value
            }
            eventLive
            businessType
            ageRating
            actors
            releaseDate
            audioLanguages
            languages
            subtitleLanguages
            assetType
            tags
            webUrl
          }
        }
        nextUrl
        page
        size
        totalResults
      }
    }
  }
`;
